/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Featured items related functions
//
// SectionTabs, for switching content sections

namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  class SectionTabs {
    // Initialize the SectionTab controller
    //
    // Expects the following options:
    //  title: selector/element object of the element for the section title (will be changed)
    //  buttonContainer: selector/element of element containing the tab buttons
    //  tab_selector: selector of all tab pages
    //
    // The buttons are found in buttonContainer with "a[data-title]".  The
    // href of the button must have a fragment containing the ID of the tab page
    // to show.  data-title attribute is the title of the tab (put in #title).
    constructor(options) {
      this.changeTab = this.changeTab.bind(this);
      this.showTab = this.showTab.bind(this);
      this.title = $(options.title);
      this.button_container = $(options.buttonContainer);
      this.tab_selector = options.tabSelector;
      this.current_tab = null;

      // data-section-tabs-location="false" disables location updating, otherwise enable it
      const update_location_data = this.button_container.data('section-tabs-location');
      this.update_location = !((update_location_data != null) && (update_location_data === false));

      $(this.tab_selector).data('section-tabs', 'tab').hide();
      $(this.tab_selector).first().show();
      if (this.button_container) { this.button_container.find('a[data-title]').click(this.changeTab); }

      // Set initial tab to the location hash, if this container has a link to the selected tab
      if (this.update_location) {
        let initial_tab = this.button_container.find(`a[href='${location.hash}']`);
        let scroll = false;
        if (!initial_tab[0]) {
          // If the location isn't found as is, try finding a title if the hash is prefixed with "tab:"
          let m;
          if (m = location.hash.match(/^#?tab:(.*)/)) {
            m[1] = decodeURIComponent(m[1]);
            initial_tab = this.button_container.find(`a[data-title='${m[1]}']`);
            scroll = true;
          }
        }

        if (initial_tab[0]) { this.showTab(initial_tab[0], scroll); }
      }
    }


    changeTab(event) {
      const button = $(event.target).closest('a');
      this.showTab(button);
      return event.preventDefault();
    }

    // Show the tab referenced by +button+
    showTab(button, scroll) {
      let tab_panel;
      if (scroll == null) { scroll = false; }
      button = $(button);
      const title = button.data('title') || button.html();
      this.title.html(title);

      // Hide all tabs
      $(this.tab_selector).hide();
      // Reset state of all buttons
      this.button_container.find('a[data-title]')
        .removeClass('selected_tab_colorfive')
        .attr('aria-selected', 'false');

      $(this.current_tab).trigger('slzr:tabhidden', {tab: this.current_tab});

      // Update the current button
      button.addClass('selected_tab_colorfive')
        .attr('aria-selected', 'true');
      const tab_link = button.attr('href').replace(/^(.*)#/, '#');

      // Show the tab
      if (tab_panel = $(tab_link)) { tab_panel.show(); }
      this.current_tab = tab_panel;
      $(tab_panel).trigger('slzr:tabshown', {tab: tab_panel, link: button});

      // Update URL to the new tab, and use replaceState when possible to bypass the browser scroll behavior
      if (this.update_location) {
        if (!scroll && 'history' in window) {
          return history.replaceState(null, '', tab_link);
        } 
          return location.replace(tab_link);
        
      }
    }
  }


  exports.SectionTabs = SectionTabs;

  // Activate section tabs on page load
  return $($ => $('[data-section-tabs="container"]').each(function() {
    const $this = $(this);

    const title = $this.find('[data-section-tabs="title"]');
    const selector = $this.data('section-tabs-selector');

    const tabs = new Slzr.SectionTabs({title, buttonContainer: $this, tabSelector: selector});
    return $this.data('section-tabs', tabs);
  }));
});